export const AnnouncementScope = {
  System: 0,
  Tenant: 1,
}

export const AnnouncementScopeDisplayName = {
  [AnnouncementScope.System]: 'System',
  [AnnouncementScope.Tenant]: 'Tenant',
}
